import { DOWNLOAD_MODE } from '../commonUtil/constants';

const initialState = {
    isLoadingLink: true,
    isLoadingManifest: true,
    viewerSetting: {
        logo: '',
        browserTitle: '',
        browserFavicon: '',
        brandingHilightColor: '#F1592A'
    },
    gdprSetting: {
        consentLocation: '',
        disclaimerMessage: '',
        privacyLink: ''
    },
    linkBasicInfo: {
        sentAt: '',
        isPasswordRequired: false,
        isExpired: false,
        isCompliancePasswordRequired: false,
        canDownload: false,
        isAllowSharingLink: false,
        interactionId: '',
        enableLiveSendDownloadOptions: false,
        downloadFormats: DOWNLOAD_MODE.OriginalFormat
    },
    sender: {
        name: '',
        email: '',
        avatar: ''
    },
    contents: [],
    contentCovers: [],
    manifests: [],
    selectedContent: {},
    selectedManifest: {},
    errorCode: '',
    errorMessage: '',
    viewerLocation: null,
    isLoadingScript: false,
    isLoadScriptSuccess: false,
    hasCustomFooter: false,
    showShareModal: false,
    creatingSession: true,
    skipSplashScreen: false,
    universalPlayerEvent: {},
    isOnlyFunctionalCookies: false,
    downloadAssets: [],
    isStrictlyNecessaryCookies: false
};

export default initialState;
